"use strict";

var _classCallCheck = require("C:\\Users\\James\\Documents\\Dev\\vet-nurse-guide\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("C:\\Users\\James\\Documents\\Dev\\vet-nurse-guide\\node_modules\\@babel\\runtime/helpers/createClass");

var Document = require("../generated/Document");

var _require = require("../../browser/documentfeatures"),
    applyDocumentFeatures = _require.applyDocumentFeatures;

exports.implementation =
/*#__PURE__*/
function () {
  function DOMParserImpl() {
    _classCallCheck(this, DOMParserImpl);
  }

  _createClass(DOMParserImpl, [{
    key: "parseFromString",
    value: function parseFromString(string, contentType) {
      switch (String(contentType)) {
        case "text/html":
          {
            return createScriptingDisabledDocument("html", contentType, string);
          }

        case "text/xml":
        case "application/xml":
        case "application/xhtml+xml":
        case "image/svg+xml":
          {
            // TODO: use a strict XML parser (sax's strict mode might work?) and create parsererror elements
            try {
              return createScriptingDisabledDocument("xml", contentType, string);
            } catch (error) {
              var document = createScriptingDisabledDocument("xml", contentType);
              var element = document.createElementNS("http://www.mozilla.org/newlayout/xml/parsererror.xml", "parsererror");
              element.textContent = error.message;
              document.appendChild(element);
              return document;
            }
          }

        default:
          throw new TypeError("Invalid contentType");
      }
    }
  }]);

  return DOMParserImpl;
}();

function createScriptingDisabledDocument(parsingMode, contentType, string) {
  var document = Document.createImpl([], {
    options: {
      parsingMode: parsingMode,
      encoding: "UTF-8",
      contentType: contentType // TODO: somehow set URL to active document's URL

    }
  }); // "scripting enabled" set to false

  applyDocumentFeatures(document, {
    FetchExternalResources: [],
    SkipExternalResources: false
  });

  if (string !== undefined) {
    document._htmlToDom.appendToDocument(string, document);
  }

  document.close();
  return document;
}